import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from '../services/api';

export const useBatiments = () => {
  return useQuery({
    queryKey: ['batiments'],
    queryFn: async () => {
      const response = await apiClient.get('/batiments');
      return response.data;
    },
  });
};

export const useCreateBatiment = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (data: { nom: string; code: string; nombreEtages: number; siteId: string }) => {
      const response = await apiClient.post('/batiments', data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['batiments'] });
    },
  });
};

export const useUpdateBatiment = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: Partial<{ nom: string; code: string; nombreEtages: number; siteId: string }> }) => {
      const response = await apiClient.patch(`/batiments/${id}`, data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['batiments'] });
    },
  });
};

export const useDeleteBatiment = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (id: string) => {
      const response = await apiClient.delete(`/batiments/${id}`);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['batiments'] });
      queryClient.invalidateQueries({ queryKey: ['pieces'] });
    },
  });
};
